import { t } from 'i18next';
import z from 'zod';

// Allows input to be null/optional, but output is validated to not be nullish
export const requireFromNullable = <T extends z.ZodTypeAny>(schema: T) => {
  return schema.nullish().transform((val, ctx) => {
    if (val === null || val === undefined) {
      ctx.addIssue({
        code: 'custom',
        message: t('errors:forms.required'),
      });
      return z.NEVER;
    }

    return val as z.output<T>;
  });
};
